import { call } from 'redux-saga/effects';
import { sagas as details } from './detailsModule';

export default function* sslCertificateSaga() {
	yield call(details);
}
